import React from "react";
import { Link } from "react-router-dom";
import { CONTACT, BRAND } from "../mock";
import { SERVICES } from "../data/services";
import { AREAS } from "../data/areas";
import { Facebook, Instagram, Linkedin, Youtube, Phone, Printer, MapPin, Mail } from "lucide-react";

const Footer = () => (
  <footer className="bg-[#0f2a5e] text-white pt-16 pb-6">
    <div className="max-w-[1240px] mx-auto px-4 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
      <div>
        <div className="font-extrabold text-[24px] mb-1">CARE<span className="text-[#7ed957]">FIRST</span></div>
        <div className="text-[10px] font-bold tracking-[0.14em] text-white/70 mb-1">HOME HEALTH SERVICES LLC</div>
        <div className="text-[12px] italic text-[#7ed957] mb-4">{BRAND.tagline}</div>
        <p className="text-white/70 text-[14px] leading-relaxed mb-4">CHAP-accredited home health care serving Columbus and Central Ohio with skilled and non-skilled services.</p>
        <div className="flex gap-3">
          {[Facebook, Instagram, Linkedin, Youtube].map((Icon, i) => (
            <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/15 hover:bg-[#4ca82f] transition-colors flex items-center justify-center"><Icon size={16} /></a>
          ))}
        </div>
      </div>
      <div>
        <h4 className="font-bold text-[16px] mb-4">Services</h4>
        <ul className="space-y-2 text-white/70 text-[14px]">
          {SERVICES.slice(0, 8).map((s) => (
            <li key={s.slug}><Link to={`/services/${s.slug}`} className="hover:text-[#7ed957] transition-colors">{s.name}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-bold text-[16px] mb-4">Service Areas</h4>
        <ul className="space-y-2 text-white/70 text-[14px] columns-1">
          {AREAS.slice(0, 9).map((a) => (
            <li key={a.slug}><Link to={`/service-areas/${a.slug}`} className="hover:text-[#7ed957] transition-colors">{a.name}, OH</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-bold text-[16px] mb-4">Contact</h4>
        <ul className="space-y-3 text-white/70 text-[14px]">
          <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-[#7ed957]" /> <span>{CONTACT.phone} / {CONTACT.phone2}</span></li>
          <li className="flex items-start gap-2"><Printer size={16} className="mt-0.5 text-[#7ed957]" /> Fax: {CONTACT.fax}</li>
          <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-[#7ed957]" /> {CONTACT.address.join(" ")}</li>
          <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 text-[#7ed957]" /> {CONTACT.email}</li>
        </ul>
        <div className="flex flex-col gap-2 mt-5">
          <Link to="/contact" className="bg-[#4ca82f] hover:bg-[#3d8a26] text-white text-center font-semibold py-2.5 rounded-full text-[13px] transition-colors">Request Care</Link>
          <Link to="/referral" className="border border-white/40 hover:bg-white/10 text-white text-center font-semibold py-2.5 rounded-full text-[13px] transition-colors">Make a Referral</Link>
        </div>
      </div>
    </div>
    <div className="max-w-[1240px] mx-auto px-4 mt-12 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-white/60 text-[13px]">
      <span>© {new Date().getFullYear()} {BRAND.full}. All Rights Reserved.</span>
      <span>CHAP Accredited · Medicare · Medicaid · PASSPORT · DODD · VA</span>
    </div>
  </footer>
);

export default Footer;
